import { HeroSection } from '../components/landing/HeroSection';
import { ConfidenceStrip } from '../components/landing/ConfidenceStrip';
import { ProblemSection } from '../components/landing/ProblemSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { DemoSection } from '../components/landing/DemoSection';
import { ProofSection } from '../components/landing/ProofSection';
import { PricingSection } from '../components/landing/PricingSection';
import { FaqSection } from '../components/landing/FaqSection';
import { FinalCtaSection } from '../components/landing/FinalCtaSection';
import { LandingFooter } from '../components/landing/LandingFooter';

export function LandingPage(): JSX.Element {
  return (
    <div className="min-h-screen bg-surface-base">
      <HeroSection />
      <ConfidenceStrip />
      <ProblemSection />
      <HowItWorksSection />
      <FeaturesSection />
      <DemoSection />
      <ProofSection />
      <PricingSection />
      <FaqSection />
      <FinalCtaSection />
      <LandingFooter />
    </div>
  );
}
